import { MAX_CHARACTER_INPUT_VALIDATION } from "@/constants/common";
import { validator } from "@/utils/validator";

export const userSettingSchema = validator.object().shape({
  emailDelivery: validator.array().label("").notRequired(),
  userDepartment: validator.string().trim().emptyToNull().label("部署").max(MAX_CHARACTER_INPUT_VALIDATION).notRequired(),
  userPosition: validator.string().trim().emptyToNull().label("役職").max(MAX_CHARACTER_INPUT_VALIDATION).notRequired(),
});
